// extracted by mini-css-extract-plugin
export default {"loading-skeleton":"ImageWrapper_loading-skeleton__-wGk5","hidden":"ImageWrapper_hidden__Y261s"};